import Vue from "vue";
import App from "./App.vue";
import Vant from "vant";
import axios from "axios";
import VueAxios from "vue-axios";
import VueCookies from "vue-cookies";
import { router } from "./router";
import "vant/lib/index.less";
import "./assets/less/style.less";
import store from "./store";

Vue.use(VueAxios, axios);
Vue.use(Vant);
Vue.use(VueCookies);

Vue.config.productionTip = false;

Vue.prototype.langingURL = process.env.VUE_APP_LandingURL;

Vue.mixin({
  computed: {
    orderNums() {
      const orderNums = window.$cookies.get("orderNums");
      let nums = store.state.cartList.length;
      if (nums == 0) {
        return null;
      }
      if (nums > 0) {
        return nums;
      }
      return orderNums;
    },
    discountValue() {
      const now = new Date().getTime();
      const expDate = new Date(2020, 3, 1).getTime();
      const endDate = new Date(2020, 4, 1).getTime();
      let discountValue = 1;
      if (now > expDate && now < endDate) {
        discountValue = 0.9;
      }
      return discountValue;
    },
  },
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
